import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import QueryParamProxy from './queryParamProxy';
import RouteParamConstants from './routeParamConstants';
import Screens from '../screens';
import rewardCenterMiddleware from '../screens/RewardCenter/utils/middleware';
import eventsMiddleware from '../screens/Events/utils/middleware';
import missionsMiddleware from '../screens/Missions/utils/middleware';
import store from '../state/store';
import { setLobbyNews } from '../state/actions/promotions';
export var PromoActionKey = {
  NO_ACTION: '',
  GO_TO_COIN_STORE: 'gotoStore',
  GO_TO_REWARDS: 'rewards',
  LAUNCH_GAME: 'game',
  REDIRECT_TO_EXTERNAL_PAGE: 'url',
  LINK_LOYALTY_CARD: 'linkLoyaltyCard',
  DOWNLOAD_MOBILE_APP: 'downloadMobileApp',
  INBOX_MESSAGE: 'inboxMessage',
  TARGET_INBOX_MESSAGE: 'targetInboxMessage',
  EVENT_CARD: 'eventCard',
  GO_TO_MISSIONS: 'missionsExplorerTab',
  GO_TO_BATTLES: 'missionsBattlesTab'
};
export var PromotionAction = {
  getActionCallback: function getActionCallback(navigation, action, notificationContext) {
    var setPromoActionRunning = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
      return null;
    };
    var type = action.type,
      game = action.game,
      externalUrl = action.externalUrl,
      eventId = action.eventId,
      trigger = action.trigger,
      message_id = action.message_id;
    var addPromoActionRunning = function addPromoActionRunning(action) {
      return setPromoActionRunning(action);
    };
    var resetPromoActionRunning = function resetPromoActionRunning() {
      return setPromoActionRunning(null);
    };
    switch (type) {
      case PromoActionKey.NO_ACTION:
        return function () {};
      case PromoActionKey.DOWNLOAD_MOBILE_APP:
        return function () {
          QueryParamProxy.dismissModal();
          alert('Please Go Download Mobile App!');
        };
      case PromoActionKey.GO_TO_COIN_STORE:
        addPromoActionRunning(type);
        return function () {
          QueryParamProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.Shop));
        };
      case PromoActionKey.EVENT_CARD:
        return function () {
          addPromoActionRunning(type);
          eventsMiddleware({
            navigation: navigation,
            notificationContext: notificationContext,
            eventId: eventId,
            resetPromoActionRunning: resetPromoActionRunning
          });
        };
      case PromoActionKey.GO_TO_REWARDS:
        return function () {
          addPromoActionRunning(type);
          rewardCenterMiddleware({
            navigation: navigation,
            notificationContext: notificationContext,
            resetPromoActionRunning: resetPromoActionRunning
          });
        };
      case PromoActionKey.LAUNCH_GAME:
        return function () {
          QueryParamProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, undefined));
          QueryParamProxy.navigate(navigation, Screens.Game, _defineProperty(_defineProperty({}, RouteParamConstants.PARAM_GAME_ID, game), RouteParamConstants.PARAM_GAME_TRIGGER, trigger));
        };
      case PromoActionKey.LINK_LOYALTY_CARD:
        return function () {
          QueryParamProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.LinkAccount));
        };
      case PromoActionKey.REDIRECT_TO_EXTERNAL_PAGE:
        return function () {
          QueryParamProxy.setQueryParams(_defineProperty(_defineProperty({}, RouteParamConstants.PARAM_MODAL, undefined), RouteParamConstants.PARAM_EXTERNAL_URL, externalUrl));
        };
      case PromoActionKey.TARGET_INBOX_MESSAGE:
      case PromoActionKey.INBOX_MESSAGE:
        return function () {
          QueryParamProxy.setQueryParams(_objectSpread(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.Social), message_id && _defineProperty({}, RouteParamConstants.PARAM_HIGHLIGHTED_MESSAGE_ID, message_id)));
        };
      case PromoActionKey.GO_TO_MISSIONS:
        return function () {
          missionsMiddleware({
            navigation: navigation,
            notificationContext: notificationContext,
            target: Screens.Missions
          });
        };
      case PromoActionKey.GO_TO_BATTLES:
        return function () {
          missionsMiddleware({
            navigation: navigation,
            notificationContext: notificationContext,
            target: Screens.Battles
          });
        };
      default:
        return function () {};
    }
  }
};
export default PromotionAction;
export var promoListHandler = function promoListHandler(_ref2) {
  var first_slide = _ref2.first_slide,
    second_slide = _ref2.second_slide,
    third_slide = _ref2.third_slide;
  var rotatingBanners = [];
  if ((first_slide === null || first_slide === void 0 ? void 0 : first_slide.length) > 0) rotatingBanners.push(first_slide);
  if ((second_slide === null || second_slide === void 0 ? void 0 : second_slide.length) > 0) rotatingBanners.push(second_slide);
  if ((third_slide === null || third_slide === void 0 ? void 0 : third_slide.length) > 0) rotatingBanners.push(third_slide);
  if (rotatingBanners.length > 0) store.dispatch(setLobbyNews(rotatingBanners));
};